<template>
    <ds-modal
        data-qa="sms-broadcast-max-recipients-modal"
        size="sm"
        center
        :is-open="isOpen"
        @close="close"
    >
        <section class="modal-intro">
            <p class="title">
                {{ $options.MESSAGE_CONSTANTS.title }}
            </p>
        </section>

        <section class="description">
            <p>
                {{ maxRecipientMessage }} <b>{{ notReceivingCount }}</b>
            </p>
        </section>

        <div class="actions">
            <ds-text-button gray data-qa="max-recipients-back-button" @click="close">
                {{ $options.MESSAGE_CONSTANTS.back }}
            </ds-text-button>

            <ds-text-button
                data-qa="send-anyway-button"
                @click="send"
            >
                {{ $options.MESSAGE_CONSTANTS.send }}
            </ds-text-button>
        </div>
    </ds-modal>
</template>


<script>
import { MAX_RECIPIENTS } from '@/components/broadcast/constants/smsBroadcast.constants';

export const MESSAGE_CONSTANTS = {
    title: 'There are too many contacts in this broadcast',
    back: 'Go back',
    send: 'Send anyways',
};

export default {
    MESSAGE_CONSTANTS,

    props: {
        isOpen: Boolean,
        total: {
            type: Number,
            required: true,
        },
        notReceiving: {
            type: Number,
            required: true,
        },
    },

    computed: {
        maxRecipientMessage() {
            const total = this.total.toString();
            const totalLimit = MAX_RECIPIENTS.toString();

            return `You’re attempting to send this broadcast to ${total} contacts, which exceeds the ${totalLimit} contact limit. If you proceed,`;
        },

        notReceivingCount() {
            const notReceiving = this.notReceiving.toString();

            return `${notReceiving} numbers won’t be sent this broadcast.`;
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },

        send() {
            this.$emit('send');
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
    .title {
        font-size: $font-size-xl;
        line-height: $line-height-xl;
    }

    .description {
        color: $color-text-subtle;
        font-size: $font-size-md;
    }

    .modal-intro {
        font-weight: $font-weight-bold;
        display: flex;
        margin-bottom: $spacing-100;
    }

    .actions {
        display: flex;
        padding-top: $spacing-300;
        justify-content: flex-end;
    }
</style>
